export default __webpack_public_path__ + "6307583a5820b0be0753019ff9df0048.png";